import React from "react";
import { Divider } from "rsuite";
import styled from "styled-components";
import { Link } from "react-router-dom";
import SocialIcons from "./SocialIcons";
let whatwedo = [
  {
    title: "Overview",
    path: "/overview",
  },
  {
    title: "KRO Programming Approaches",
    path: "/programmingapproaches",
  },
  {
    title: "Livelihood & Food Security",
    path: "/livelihoodfoodsecurity",
  },
  {
    title: "WASH",
    path: "/wash",
  },
  {
    title: "Cash-based Interventions",
    path: "/cashbasedinterventions",
  },
  {
    title: "Protection",
    path: "/protection",
  },
  {
    title: "Shelter",
    path: "/shelter",
  },
  {
    title: "SBC",
    path: "/sbc",
  },
];
let media = [
  {
    title: "News Letter",
    path: "/newsletter",
  },
  {
    title: "Success Stories",
    path: "/successstories",
  },
  {
    title: "Photo Gallery",
    path: "/photogallery",
  },
  {
    title: "Video Gallery",
    path: "/videogallery",
  },
];

const Sitemap = () => {
  return (
    <Main>
      <Container>
        <Block>
          <Title>About Us</Title>
          <Item to="/aboutus">Who We Are</Item>
          <Item to="/wherewework">Where We Work</Item>
          <Item to="/historymilestone">History / Milestone</Item>
          <Item to="/accountability">Accountability</Item>
          <Item to="/complaintform">Complaints & Feedback</Item>
          <Item to="/ourteam">Our Team</Item>
          <Item to="/faq">FAQs</Item>
        </Block>

        <Block>
          <Title>What We Do</Title>
          {whatwedo.map((item) => {
            return <Item to={item.path}>{item.title}</Item>;
          })}
        </Block>

        <Block>
          <Title>Media</Title>
          {media.map((item) => {
            return <Item to={item.path}>{item.title}</Item>;
          })}

          <Block>
            <Title>Get Involved</Title>
            <Item to="/careeropportunities">Career Opportunities</Item>
            <Item to="/rfps">RFQs & RFPs</Item>
          </Block>
        </Block>

        <Block>
          <Single to="/impact">Impact</Single>
          <Single to="/contactus">Contact Us</Single>
          <SocialIcons />
          <FuturePlan>
            Designed & Developed By{" "}
            <Highlight>
              <a
                href="https://www.facebook.com/nasratahmad.hashme"
                target="_blank"
              >
                Nasrat Qurishe
              </a>
            </Highlight>
          </FuturePlan>
        </Block>
      </Container>
      <Divider />
      <Section>
        <Group>
          <Heading>Vision</Heading>
          <Description>
            KRO envisions a future where local communities in Afghanistan thrive
            through robust economic development, enhanced capacities, and
            sustainable practices. We aspire to empower individuals, including
            women and those with disabilities, to reach their full potential and
            contribute to their communities' growth and prosperity.
          </Description>
        </Group>

        <Group>
          <Heading>Mission</Heading>
          <Description>
            KRO addresses humanitarian needs and rehabilitates communities in
            Afghanistan. We empower local populations, including women and
            individuals with disabilities, while promoting sustainable
            development and ensuring access to essential resources for all.
          </Description>
        </Group>

        <Group>
          <Heading>Our Goal</Heading>
          <Description>
            The primary goal of KRO is to assist and uplift the distressed,
            needy, neglected, and vulnerable populations in Afghanistan, with a
            particular focus on women and children. By providing essential
            assistance, the organization aims to contribute to the social and
            economic development of these communities, enhancing their lives and
            overall conditions. The emphasis on sustainability and
            self-determination underscores KRO's commitment to fostering lasting
            positive change at the community level.
          </Description>
        </Group>
      </Section>
    </Main>
  );
};

export default Sitemap;

let Main = styled.div`
  display: grid;
  width: 100vw;
  background: #13162b;
  overflow: hidden;
  padding: 40px;
  box-sizing: border-box;
`;

let Container = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  padding: 50px 0px 0px 0px;
  box-sizing: border-box;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 30px;
  }
`;

let Block = styled.div`
  display: flex;
  flex-direction: column;
`;

let Title = styled.span`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  margin-block: 15px;
`;

let Item = styled(Link)`
  font-size: 0.9rem;
  font-family: "Poppins";
  font-weight: 400;
  color: #fff;
  text-decoration: none !important;
  :hover {
    color: #c6c661;
  }
  :before {
    content: "•";
    font-size: 2rem;
    margin-right: 15px;
    vertical-align: middle;
  }
`;

let Single = styled(Link)`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  margin-block: 15px;
  text-decoration: none !important;
  :hover {
    color: #c6c661;
  }
`;

let Section = styled.div``;

let Group = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-block: 30px;
`;

let Heading = styled.span`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
`;

let Description = styled.span`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 0.8rem;
  margin-left: 12px;
  margin-top: 5px;
  color: #fff;
`;

let FuturePlan = styled.div`
  font-size: 0.9rem;
  font-family: "Poppins";
  font-weight: 400;
  color: #fff;
  text-decoration: none !important;
  margin-top: 20px;
`;
let Highlight = styled.span`
  font-size: 1rem;
  font-family: "Poppins";
  font-weight: 700;
  color: #00b1ea;
  text-decoration: none !important;
  @media (max-width: 768px) {
    display: block;
  }
`;
